import { QuizQuestion } from '../../types';

export const regexModule1QuestionBank: QuizQuestion[] = [
  // Basic Pattern Matching (20 questions)
  {
    id: 'q001',
    question: 'What does the dot (.) metacharacter match in regex?',
    choices: [
      'Only the literal dot character',
      'Any single character except newline',
      'Any whitespace character',
      'Any alphabetic character',
    ],
    correctAnswer: 1,
    explanation:
      'The dot (.) metacharacter matches any single character except newline. This includes letters, digits, spaces, punctuation, and symbols.',
  },
  {
    id: 'q002',
    question: 'Why should you use raw strings (r"pattern") for regex patterns in Python?',
    choices: [
      'They make the regex run faster',
      'They are required by the re module',
      'They prevent Python from interpreting backslashes as escape characters',
      'They make patterns case-insensitive',
    ],
    correctAnswer: 2,
    explanation:
      'Raw strings prevent Python from interpreting backslashes as escape characters, making regex patterns more readable and avoiding confusion between Python string escapes and regex escapes.',
  },
  {
    id: 'q003',
    question: 'Are regex patterns case-sensitive by default?',
    choices: [
      'Yes, they are case-sensitive',
      'No, they are case-insensitive',
      'It depends on the programming language',
      'Only for alphabetic characters',
    ],
    correctAnswer: 0,
    explanation:
      'Yes, regex patterns are case-sensitive by default. "A" and "a" are treated as different characters unless you use the re.IGNORECASE flag.',
  },
  {
    id: 'q004',
    question: 'How do you match a literal dot character in regex?',
    choices: [
      'Use . directly',
      'Use \\. to escape it',
      'Use [.] in square brackets',
      'Both B and C are correct',
    ],
    correctAnswer: 3,
    explanation:
      'Both \\. (escaping with backslash) and [.] (in square brackets) will match a literal dot. The dot loses its special meaning when escaped or inside character classes.',
  },
  {
    id: 'q005',
    question: 'What is the difference between re.search() and re.findall()?',
    choices: [
      'search() is faster than findall()',
      'search() finds the first match, findall() finds all matches',
      'search() is case-sensitive, findall() is not',
      'There is no difference',
    ],
    correctAnswer: 1,
    explanation:
      're.search() returns the first match object (or None), while re.findall() returns a list of all matches in the string. Use search() when you only need to know if a pattern exists, and findall() when you need all occurrences.',
  },
  {
    id: 'q006',
    question: 'What will the pattern "cat" match in the text "The cat and dog are cats"?',
    choices: [
      'Only the word "cat"',
      'Both "cat" and the "cat" part of "cats"',
      'Only "cats"',
      'Nothing, because the pattern is too simple',
    ],
    correctAnswer: 1,
    explanation:
      'The pattern "cat" will match both the standalone word "cat" and the "cat" substring within "cats". Regex matches substrings unless anchored.',
  },
  {
    id: 'q007',
    question: 'Which Python function should you use to check if a string starts with a pattern?',
    choices: ['re.match()', 're.search()', 're.findall()', 're.split()'],
    correctAnswer: 0,
    explanation:
      're.match() only matches at the beginning of a string, making it perfect for checking if a string starts with a pattern.',
  },
  {
    id: 'q008',
    question: "What happens when you use a regex pattern that doesn't match anything?",
    choices: [
      'Python raises an exception',
      're.search() returns None',
      'The program crashes',
      're.search() returns an empty string',
    ],
    correctAnswer: 1,
    explanation:
      "When a regex pattern doesn't match, re.search() returns None. Always check for None before accessing match methods.",
  },
  {
    id: 'q009',
    question: 'In the pattern "hello world", what does the space represent?',
    choices: [
      'A special metacharacter',
      'A literal space character',
      'Any whitespace character',
      'An optional character',
    ],
    correctAnswer: 1,
    explanation:
      'Spaces in regex patterns are literal characters. They match exactly one space character in the target string.',
  },
  {
    id: 'q010',
    question: 'What will re.findall("a", "banana") return?',
    choices: ['["a"]', '["a", "a", "a"]', '["an", "an"]', '"aaa"'],
    correctAnswer: 1,
    explanation:
      're.findall() returns a list of all non-overlapping matches. "banana" contains three "a" characters, so it returns ["a", "a", "a"].',
  },
  {
    id: 'q011',
    question: 'Which regex flag makes pattern matching case-insensitive?',
    choices: ['re.IGNORECASE', 're.CASE_INSENSITIVE', 're.IGNORE', 're.NOCASE'],
    correctAnswer: 0,
    explanation:
      're.IGNORECASE (or re.I) makes regex matching case-insensitive, so "Hello" would match "hello", "HELLO", etc.',
  },
  {
    id: 'q012',
    question: 'What is a metacharacter in regex?',
    choices: [
      "Any character that's not a letter",
      'A character with special meaning in regex',
      'A character that must be uppercase',
      'A character that represents metadata',
    ],
    correctAnswer: 1,
    explanation:
      'Metacharacters are characters with special meaning in regex, like . (any character), * (zero or more), + (one or more), etc.',
  },
  {
    id: 'q013',
    question: 'How do you make a regex pattern match case-insensitively in Python?',
    choices: [
      'Use uppercase letters in the pattern',
      'Add the re.IGNORECASE flag',
      'Use the .lower() method first',
      "It's case-insensitive by default",
    ],
    correctAnswer: 1,
    explanation:
      'Use re.IGNORECASE flag: re.search("hello", "HELLO", re.IGNORECASE) will match successfully.',
  },
  {
    id: 'q014',
    question: 'What does re.match("test", "testing 123") return?',
    choices: ['None', 'A match object for "test"', 'A match object for "testing"', 'An error'],
    correctAnswer: 1,
    explanation:
      're.match() checks if the pattern matches at the beginning of the string. Since "testing 123" starts with "test", it returns a match object.',
  },
  {
    id: 'q015',
    question: 'Which is the correct way to write a regex pattern in Python?',
    choices: ['"hello"', 'r"hello"', '/hello/', 'Both A and B are correct'],
    correctAnswer: 3,
    explanation:
      'Both regular strings and raw strings work for simple patterns. Raw strings (r"") are preferred because they handle backslashes better.',
  },
  {
    id: 'q016',
    question: 'What will the pattern "." match in "a.b"?',
    choices: [
      'Only the literal dot',
      'Only the letters a and b',
      'Each character: "a", ".", and "b"',
      'The entire string "a.b"',
    ],
    correctAnswer: 2,
    explanation:
      'The dot metacharacter matches any single character. In "a.b", it will match "a", then ".", then "b" as separate matches.',
  },
  {
    id: 'q017',
    question: 'What is the purpose of the re module in Python?',
    choices: [
      'To handle file operations',
      'To work with regular expressions',
      'To perform mathematical calculations',
      'To manage memory',
    ],
    correctAnswer: 1,
    explanation:
      'The re module provides support for regular expressions in Python, including functions like search(), match(), findall(), and sub().',
  },
  {
    id: 'q018',
    question: 'In regex, what makes a character "literal"?',
    choices: [
      "It's written in lowercase",
      'It matches exactly itself with no special meaning',
      "It's inside quotes",
      "It's a letter from the alphabet",
    ],
    correctAnswer: 1,
    explanation:
      'A literal character matches exactly itself. For example, "a" matches the letter "a", and "5" matches the digit "5".',
  },
  {
    id: 'q019',
    question: "What happens if you don't import the re module before using regex functions?",
    choices: [
      'Python will import it automatically',
      'The functions will work but slower',
      "You'll get a NameError",
      "The regex won't work properly",
    ],
    correctAnswer: 2,
    explanation:
      'You must import the re module with "import re" before using regex functions, otherwise you\'ll get a NameError.',
  },
  {
    id: 'q020',
    question: 'Which function would you use to replace text using regex?',
    choices: ['re.replace()', 're.sub()', 're.change()', 're.switch()'],
    correctAnswer: 1,
    explanation:
      're.sub() is used to substitute (replace) text that matches a regex pattern with new text.',
  },

  // Escaping and Special Characters (25 questions)
  {
    id: 'q021',
    question: 'How do you match a literal asterisk (*) character?',
    choices: [
      'Use * directly',
      'Use \\* to escape it',
      'Use [*] in brackets',
      'Both B and C are correct',
    ],
    correctAnswer: 3,
    explanation:
      'Both \\* (escaped) and [*] (in character class) will match a literal asterisk since * is a metacharacter.',
  },
  {
    id: 'q022',
    question: 'What character is used for escaping in regex?',
    choices: ['Forward slash /', 'Backslash \\', 'Caret ^', 'Pipe |'],
    correctAnswer: 1,
    explanation:
      'The backslash (\\) is used for escaping in regex. It removes the special meaning from metacharacters.',
  },
  {
    id: 'q023',
    question: 'How do you match a literal question mark (?)?',
    choices: [
      'Use ? directly',
      'Use \\? to escape it',
      'Use [?] in brackets',
      'Both B and C are correct',
    ],
    correctAnswer: 3,
    explanation: 'Since ? is a metacharacter (zero or one), use \\? or [?] to match it literally.',
  },
  {
    id: 'q024',
    question: 'What does \\n represent in regex?',
    choices: ['The letter n', 'A newline character', "Nothing, it's invalid", 'Any number'],
    correctAnswer: 1,
    explanation:
      '\\n represents a newline character in regex, just like in many programming languages.',
  },
  {
    id: 'q025',
    question: 'How do you match a literal backslash (\\) character?',
    choices: [
      'Use \\ directly',
      'Use \\\\ (double backslash)',
      'Use [\\] in brackets',
      'Use \\\\\\\\ (four backslashes) in raw strings',
    ],
    correctAnswer: 1,
    explanation:
      'Use \\\\ to match a literal backslash. In raw strings r"\\\\", the pattern is two backslashes, which matches one literal backslash.',
  },
  {
    id: 'q026',
    question: 'What is the difference between "\\t" and r"\\t" in Python regex?',
    choices: [
      'No difference',
      '"\\t" is a tab character, r"\\t" matches literal \\t',
      'r"\\t" is faster',
      '"\\t" is case-sensitive, r"\\t" is not',
    ],
    correctAnswer: 1,
    explanation:
      '"\\t" represents a tab character, while r"\\t" is a raw string representing the literal characters \\ and t.',
  },
  {
    id: 'q027',
    question: 'Which characters need to be escaped to match them literally?',
    choices: [
      'Only letters',
      'Only numbers',
      'Metacharacters like . * + ? ^ $ ( ) [ ] { } \\ |',
      'All punctuation',
    ],
    correctAnswer: 2,
    explanation:
      'Metacharacters have special meanings, so they need escaping to match literally: . * + ? ^ $ ( ) [ ] { } \\ |',
  },
  {
    id: 'q028',
    question: 'What does \\d represent in regex?',
    choices: ['The letter d', 'Any digit (0-9)', 'A deleted character', 'A double character'],
    correctAnswer: 1,
    explanation: '\\d is a shorthand character class that matches any digit from 0 to 9.',
  },
  {
    id: 'q029',
    question: 'How do you match literal parentheses ( ) in regex?',
    choices: [
      'Use ( ) directly',
      'Use \\( \\) to escape them',
      'Use [( )] in brackets',
      'Both B and C work',
    ],
    correctAnswer: 3,
    explanation:
      'Parentheses are metacharacters for grouping, so use \\( \\) or [( )] to match them literally.',
  },
  {
    id: 'q030',
    question: 'What does \\w represent in regex?',
    choices: [
      'Any whitespace',
      'The letter w',
      'Any word character (letters, digits, underscore)',
      'Any wide character',
    ],
    correctAnswer: 2,
    explanation:
      '\\w matches word characters: letters (a-z, A-Z), digits (0-9), and underscore (_).',
  },
  {
    id: 'q031',
    question: 'What does \\s represent in regex?',
    choices: [
      'The letter s',
      'Any whitespace character',
      'Any special character',
      'A string character',
    ],
    correctAnswer: 1,
    explanation:
      '\\s matches any whitespace character including space, tab, newline, carriage return, etc.',
  },
  {
    id: 'q032',
    question: 'How do you match a literal dollar sign ($)?',
    choices: [
      'Use $ directly',
      'Use \\$ to escape it',
      'Use [$] in brackets',
      'Both B and C are correct',
    ],
    correctAnswer: 3,
    explanation: '$ is a metacharacter for end-of-line, so use \\$ or [$] to match it literally.',
  },
  {
    id: 'q033',
    question: 'What is the problem with using "\\d+" in a regular string (not raw)?',
    choices: [
      "It won't match digits",
      'Python interprets \\d as an escape sequence',
      "It's slower than raw strings",
      "There's no problem",
    ],
    correctAnswer: 1,
    explanation:
      'In regular strings, Python processes escape sequences. Use raw strings r"\\d+" to avoid this issue.',
  },
  {
    id: 'q034',
    question: 'How do you match a literal caret (^) character?',
    choices: [
      'Use ^ directly',
      'Use \\^ to escape it',
      'Use [^] in brackets',
      'Both B and C are correct',
    ],
    correctAnswer: 3,
    explanation:
      '^ is a metacharacter for start-of-line, so use \\^ or place it in brackets [^] to match literally.',
  },
  {
    id: 'q035',
    question: 'What does \\t represent in regex?',
    choices: ['The letter t', 'A tab character', 'Any text character', 'A temporary character'],
    correctAnswer: 1,
    explanation:
      '\\t represents a tab character in regex, just like in most programming languages.',
  },
  {
    id: 'q036',
    question: 'How do you match literal square brackets [ ]?',
    choices: [
      'Use [ ] directly',
      'Use \\[ \\] to escape them',
      'Put them inside parentheses',
      'You cannot match them literally',
    ],
    correctAnswer: 1,
    explanation:
      'Square brackets define character classes, so use \\[ \\] to match them literally.',
  },
  {
    id: 'q037',
    question: 'What does \\r represent in regex?',
    choices: [
      'The letter r',
      'A carriage return character',
      'Any repeated character',
      'A reverse character',
    ],
    correctAnswer: 1,
    explanation:
      '\\r represents a carriage return character, often used with \\n for Windows line endings.',
  },
  {
    id: 'q038',
    question: 'How do you match literal curly braces { }?',
    choices: [
      'Use { } directly',
      'Use \\{ \\} to escape them',
      'Use [{ }] in brackets',
      'Both A and B work',
    ],
    correctAnswer: 3,
    explanation:
      'Curly braces can often be used literally, but escaping \\{ \\} is safer and more explicit.',
  },
  {
    id: 'q039',
    question: 'What is the most common reason regex patterns fail?',
    choices: [
      'Using the wrong programming language',
      'Forgetting to escape metacharacters when matching literally',
      'Using too many characters',
      'Not using enough memory',
    ],
    correctAnswer: 1,
    explanation:
      'A common mistake is using metacharacters like . * + without escaping when you want to match them literally.',
  },
  {
    id: 'q040',
    question: "What does \\b represent in regex (we'll learn more about this later)?",
    choices: ['The letter b', 'A backspace character', 'A word boundary', 'A binary character'],
    correctAnswer: 2,
    explanation:
      '\\b represents a word boundary - the position between a word character and non-word character.',
  },
  {
    id: 'q041',
    question: 'How do you match a literal pipe | character?',
    choices: [
      'Use | directly',
      'Use \\| to escape it',
      'Use [|] in brackets',
      'Both B and C are correct',
    ],
    correctAnswer: 3,
    explanation: '| is the alternation metacharacter, so use \\| or [|] to match it literally.',
  },
  {
    id: 'q042',
    question: "What's the safest approach when you're unsure if a character is a metacharacter?",
    choices: [
      'Always escape it',
      'Never escape it',
      'Test it first',
      'Look it up in documentation',
    ],
    correctAnswer: 0,
    explanation:
      'When in doubt, escape it. Escaping a non-metacharacter usually just matches it literally, which is harmless.',
  },
  {
    id: 'q043',
    question: 'What does \\f represent in regex?',
    choices: ['The letter f', 'A form feed character', 'A file character', 'A function character'],
    correctAnswer: 1,
    explanation: '\\f represents a form feed character, used for page breaks in some text formats.',
  },
  {
    id: 'q044',
    question: 'What does \\v represent in regex?',
    choices: [
      'The letter v',
      'A vertical tab character',
      'A variable character',
      'A value character',
    ],
    correctAnswer: 1,
    explanation: '\\v represents a vertical tab character, less commonly used than regular tabs.',
  },
  {
    id: 'q045',
    question: 'How do you match a literal plus (+) character?',
    choices: [
      'Use + directly',
      'Use \\+ to escape it',
      'Use [+] in brackets',
      'Both B and C are correct',
    ],
    correctAnswer: 3,
    explanation:
      '+ is a quantifier metacharacter (one or more), so use \\+ or [+] to match it literally.',
  },

  // Python re Module Functions (25 questions)
  {
    id: 'q046',
    question: 'What does re.search() return when it finds a match?',
    choices: ['The matched string', 'A Match object', 'True', 'The position of the match'],
    correctAnswer: 1,
    explanation:
      're.search() returns a Match object containing information about the match, including the matched text and its position.',
  },
  {
    id: 'q047',
    question: 'What does re.match() do differently from re.search()?',
    choices: [
      "It's faster",
      'It only matches at the beginning of the string',
      'It finds all matches',
      "It's case-insensitive",
    ],
    correctAnswer: 1,
    explanation:
      're.match() only checks if the pattern matches at the very beginning of the string, while re.search() looks anywhere in the string.',
  },
  {
    id: 'q048',
    question: 'What does re.findall() return?',
    choices: [
      'A Match object',
      'The first match only',
      'A list of all matches',
      'The number of matches',
    ],
    correctAnswer: 2,
    explanation:
      're.findall() returns a list containing all non-overlapping matches of the pattern in the string.',
  },
  {
    id: 'q049',
    question: 'How do you get the matched text from a Match object?',
    choices: ['match.text()', 'match.group()', 'match.string()', 'match.result()'],
    correctAnswer: 1,
    explanation:
      'Use match.group() or match.group(0) to get the entire matched text from a Match object.',
  },
  {
    id: 'q050',
    question: 'What does re.split() do?',
    choices: [
      'Splits the regex pattern',
      'Splits the string using regex as delimiter',
      'Splits the match object',
      'Splits the search results',
    ],
    correctAnswer: 1,
    explanation: 're.split() splits a string into a list using a regex pattern as the delimiter.',
  },
  {
    id: 'q051',
    question: 'What should you always check before calling methods on a Match object?',
    choices: [
      'If the pattern is valid',
      'If the Match object is not None',
      'If the string is not empty',
      'If the regex engine is loaded',
    ],
    correctAnswer: 1,
    explanation:
      'Always check if the Match object is not None, because search() and match() return None when no match is found.',
  },
  {
    id: 'q052',
    question: 'What does match.start() return?',
    choices: [
      'The beginning of the string',
      'The start position of the match',
      'The first character of the match',
      'True if the match starts at position 0',
    ],
    correctAnswer: 1,
    explanation:
      'match.start() returns the starting index position of the match in the original string.',
  },
  {
    id: 'q053',
    question: 'What does match.end() return?',
    choices: [
      'The end of the string',
      'The end position of the match (exclusive)',
      'The last character of the match',
      'True if the match ends at the string end',
    ],
    correctAnswer: 1,
    explanation:
      'match.end() returns the ending index position of the match (exclusive), so match[start():end()] gives the matched text.',
  },
  {
    id: 'q054',
    question: 'What does match.span() return?',
    choices: [
      'The length of the match',
      'A tuple (start, end) of the match positions',
      'The matched text',
      'The time span of the search',
    ],
    correctAnswer: 1,
    explanation:
      'match.span() returns a tuple containing the start and end positions of the match.',
  },
  {
    id: 'q055',
    question: 'What does re.sub() do?',
    choices: [
      'Subtracts from the string',
      'Substitutes (replaces) matches with new text',
      'Creates a substring',
      'Submits the regex for processing',
    ],
    correctAnswer: 1,
    explanation:
      're.sub() substitutes all occurrences of the pattern with replacement text and returns the modified string.',
  },
  {
    id: 'q056',
    question: "What does re.subn() return that re.sub() doesn't?",
    choices: [
      'The original string',
      'A tuple of (modified_string, number_of_substitutions)',
      'Only the number of substitutions',
      'The positions of substitutions',
    ],
    correctAnswer: 1,
    explanation:
      're.subn() returns a tuple containing both the modified string and the number of substitutions made.',
  },
  {
    id: 'q057',
    question: "What happens if re.search() doesn't find a match?",
    choices: [
      'It raises an exception',
      'It returns an empty string',
      'It returns None',
      'It returns False',
    ],
    correctAnswer: 2,
    explanation:
      're.search() returns None when no match is found. Always check for None before using the result.',
  },
  {
    id: 'q058',
    question: 'What does re.finditer() return?',
    choices: [
      'A list of matches',
      'An iterator of Match objects',
      'The number of matches',
      'A string of all matches',
    ],
    correctAnswer: 1,
    explanation:
      're.finditer() returns an iterator that yields Match objects for each match, useful for processing large texts efficiently.',
  },
  {
    id: 'q059',
    question: 'How do you compile a regex pattern for reuse?',
    choices: [
      're.compile(pattern)',
      're.prepare(pattern)',
      're.build(pattern)',
      're.create(pattern)',
    ],
    correctAnswer: 0,
    explanation:
      're.compile() creates a compiled regex pattern object that can be reused multiple times efficiently.',
  },
  {
    id: 'q060',
    question: "What's the advantage of compiling a regex pattern?",
    choices: [
      'It makes the pattern case-insensitive',
      "It's more efficient when using the pattern multiple times",
      'It makes the pattern more readable',
      'It automatically escapes metacharacters',
    ],
    correctAnswer: 1,
    explanation:
      "Compiled patterns are more efficient when used multiple times because the pattern is parsed once rather than every time it's used.",
  },
  {
    id: 'q061',
    question: 'What does re.escape() do?',
    choices: [
      'Removes escape characters',
      'Escapes all special regex characters in a string',
      'Creates an escape sequence',
      'Validates escape characters',
    ],
    correctAnswer: 1,
    explanation:
      're.escape() automatically escapes all regex metacharacters in a string, making it safe to use as a literal pattern.',
  },
  {
    id: 'q062',
    question: 'When should you use re.escape()?',
    choices: [
      'Always, for safety',
      'When you want to match a string literally that might contain metacharacters',
      'Only with compiled patterns',
      "Never, it's deprecated",
    ],
    correctAnswer: 1,
    explanation:
      'Use re.escape() when you need to search for a literal string that might contain regex metacharacters.',
  },
  {
    id: 'q063',
    question: 'What does re.purge() do?',
    choices: [
      'Deletes all compiled patterns from cache',
      'Removes matches from a string',
      'Clears the regex cache',
      'Purges invalid patterns',
    ],
    correctAnswer: 2,
    explanation: 're.purge() clears the internal cache of compiled regular expressions.',
  },
  {
    id: 'q064',
    question:
      "What's the difference between re.search(pattern, string) and pattern.search(string)?",
    choices: [
      'No difference in functionality',
      'The second form is faster',
      'The first form is more readable',
      'The second form only works with compiled patterns',
    ],
    correctAnswer: 0,
    explanation:
      'Both forms work the same way. The second form requires a compiled pattern object, while the first compiles the pattern each time.',
  },
  {
    id: 'q065',
    question: 'What does the count parameter in re.sub() do?',
    choices: [
      'Counts the number of matches',
      'Limits the number of replacements',
      'Sets the starting position',
      'Defines the replacement string length',
    ],
    correctAnswer: 1,
    explanation:
      'The count parameter limits the maximum number of pattern occurrences to replace. Default is 0 (replace all).',
  },
  {
    id: 'q066',
    question: 'How do you perform a case-insensitive search?',
    choices: [
      'Convert the string to lowercase first',
      'Use the re.IGNORECASE flag',
      'Use the re.NOCASE flag',
      'Use the .lower() method on the pattern',
    ],
    correctAnswer: 1,
    explanation:
      'Use the re.IGNORECASE flag (or re.I) as the third parameter in regex functions for case-insensitive matching.',
  },
  {
    id: 'q067',
    question: 'What does re.fullmatch() do?',
    choices: [
      'Finds all possible matches',
      'Matches the entire string (like ^pattern$)',
      'Returns the longest match',
      'Matches with full details',
    ],
    correctAnswer: 1,
    explanation:
      're.fullmatch() only succeeds if the entire string matches the pattern, equivalent to anchoring with ^ and $.',
  },
  {
    id: 'q068',
    question: 'What happens if you use re.sub() with an invalid replacement string?',
    choices: [
      'It returns the original string',
      'It raises an exception',
      'It replaces with empty string',
      'It ignores the replacement',
    ],
    correctAnswer: 1,
    explanation:
      'Invalid replacement strings (like invalid backreferences) raise exceptions like re.error.',
  },
  {
    id: 'q069',
    question: "What's the difference between using flags in re.search() vs re.compile()?",
    choices: [
      'No difference',
      'Flags in compile() affect all uses of that pattern',
      'Flags in search() are faster',
      'Flags in compile() are ignored',
    ],
    correctAnswer: 1,
    explanation:
      'When you compile a pattern with flags, those flags apply to all uses of that compiled pattern object.',
  },
  {
    id: 'q070',
    question: 'What does re.template() do?',
    choices: [
      'Creates a template for patterns',
      'Compiles a pattern for substitution templates',
      'Formats template strings',
      "It's deprecated and not used",
    ],
    correctAnswer: 3,
    explanation:
      're.template() was deprecated and removed. Use re.compile() for all pattern compilation needs.',
  },

  // Real-world Applications (30 questions)
  {
    id: 'q071',
    question: 'What regex pattern would match a simple email address like "user@domain.com"?',
    choices: [
      'r"\\w+@\\w+\\.\\w+"',
      'r".*@.*\\..*"',
      'r"[a-z]+@[a-z]+\\.[a-z]+"',
      'All of the above would work',
    ],
    correctAnswer: 3,
    explanation:
      'All patterns would match basic email formats, though they have different levels of specificity and flexibility.',
  },
  {
    id: 'q072',
    question: 'Which pattern would match phone numbers like "123-456-7890"?',
    choices: [
      'r"\\d{3}-\\d{3}-\\d{4}"',
      'r"[0-9]{3}-[0-9]{3}-[0-9]{4}"',
      'r"\\d\\d\\d-\\d\\d\\d-\\d\\d\\d\\d"',
      'All of the above',
    ],
    correctAnswer: 3,
    explanation:
      'All three patterns would match the format "123-456-7890". The first two are more concise using quantifiers.',
  },
  {
    id: 'q073',
    question: 'What would be a good pattern to match a date in MM/DD/YYYY format?',
    choices: [
      'r"\\d{2}/\\d{2}/\\d{4}"',
      'r"\\d\\d/\\d\\d/\\d\\d\\d\\d"',
      'r"[0-9]{2}/[0-9]{2}/[0-9]{4}"',
      'All of the above',
    ],
    correctAnswer: 3,
    explanation:
      'All patterns match MM/DD/YYYY format. The first is most concise using {n} quantifiers.',
  },
  {
    id: 'q074',
    question: 'To match a URL starting with http:// or https://, which pattern works?',
    choices: ['r"http://.*"', 'r"https?://.*"', 'r"http(s)?://.*"', 'Both B and C'],
    correctAnswer: 3,
    explanation:
      'Both "https?://" (s is optional) and "http(s)?://" (s group is optional) match both http:// and https://.',
  },
  {
    id: 'q075',
    question: 'What pattern would match credit card numbers like "1234 5678 9012 3456"?',
    choices: [
      'r"\\d{4} \\d{4} \\d{4} \\d{4}"',
      'r"\\d\\d\\d\\d \\d\\d\\d\\d \\d\\d\\d\\d \\d\\d\\d\\d"',
      'r"[0-9]{4} [0-9]{4} [0-9]{4} [0-9]{4}"',
      'All of the above',
    ],
    correctAnswer: 3,
    explanation:
      'All patterns match four groups of four digits separated by spaces. The first is most readable.',
  },
  {
    id: 'q076',
    question: 'To extract all hashtags from text (like #python #regex), what pattern would work?',
    choices: ['r"#\\w+"', 'r"#[a-zA-Z0-9_]+"', 'r"#[^\\s]+"', 'Both A and B'],
    correctAnswer: 3,
    explanation:
      'Both #\\w+ and #[a-zA-Z0-9_]+ work since \\w includes letters, digits, and underscore.',
  },
  {
    id: 'q077',
    question: 'What pattern would match IP addresses like "192.168.1.1"?',
    choices: [
      'r"\\d+\\.\\d+\\.\\d+\\.\\d+"',
      'r"\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}"',
      'r"[0-9]+\\.[0-9]+\\.[0-9]+\\.[0-9]+"',
      'All of the above',
    ],
    correctAnswer: 3,
    explanation:
      'All would match IP address format. The second is most precise, limiting each part to 1-3 digits.',
  },
  {
    id: 'q078',
    question: 'To match time in 24-hour format like "14:30", what pattern works?',
    choices: ['r"\\d{2}:\\d{2}"', 'r"[0-9]{2}:[0-9]{2}"', 'r"\\d\\d:\\d\\d"', 'All of the above'],
    correctAnswer: 3,
    explanation: 'All patterns match two digits, colon, two digits format for time.',
  },
  {
    id: 'q079',
    question: 'What pattern would match postal codes like "12345" or "12345-6789"?',
    choices: ['r"\\d{5}"', 'r"\\d{5}-\\d{4}"', 'r"\\d{5}(-\\d{4})?"', 'r"\\d{5}|\\d{5}-\\d{4}"'],
    correctAnswer: 2,
    explanation:
      'Pattern r"\\d{5}(-\\d{4})?" matches 5 digits optionally followed by dash and 4 more digits.',
  },
  {
    id: 'q080',
    question: 'To match hexadecimal colors like "#FF0000" or "#f0f", what pattern works?',
    choices: [
      'r"#[0-9A-Fa-f]{6}"',
      'r"#[0-9A-Fa-f]{3}"',
      'r"#[0-9A-Fa-f]{3,6}"',
      'r"#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})"',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern r"#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})" matches # followed by either 3 or 6 hex digits.',
  },
  {
    id: 'q081',
    question: 'What pattern would match social security numbers like "123-45-6789"?',
    choices: [
      'r"\\d{3}-\\d{2}-\\d{4}"',
      'r"[0-9]{3}-[0-9]{2}-[0-9]{4}"',
      'r"\\d\\d\\d-\\d\\d-\\d\\d\\d\\d"',
      'All of the above',
    ],
    correctAnswer: 3,
    explanation:
      'All patterns match the SSN format: three digits, dash, two digits, dash, four digits.',
  },
  {
    id: 'q082',
    question: 'To extract mentions from social media (like @username), what pattern works?',
    choices: ['r"@\\w+"', 'r"@[a-zA-Z0-9_]+"', 'r"@[^\\s]+"', 'Both A and B'],
    correctAnswer: 3,
    explanation:
      'Both @\\w+ and @[a-zA-Z0-9_]+ work for typical usernames. \\w includes letters, digits, and underscore.',
  },
  {
    id: 'q083',
    question: 'What pattern would match file extensions like ".txt", ".pdf", ".html"?',
    choices: [
      'r"\\.\\w+"',
      'r"\\.[a-zA-Z]+"',
      'r"\\.[a-z]{2,4}"',
      'All could work depending on requirements',
    ],
    correctAnswer: 3,
    explanation:
      'Different patterns have different specificity. The choice depends on what file extensions you want to match.',
  },
  {
    id: 'q084',
    question: 'To match currency amounts like "$123.45", what pattern works?',
    choices: [
      'r"\\$\\d+\\.\\d{2}"',
      'r"\\$[0-9]+\\.[0-9]{2}"',
      'r"\\$\\d+\\.\\d\\d"',
      'All of the above',
    ],
    correctAnswer: 3,
    explanation: 'All patterns match dollar sign, digits, dot, and exactly two decimal digits.',
  },
  {
    id: 'q085',
    question: 'What pattern would match HTML tags like "<div>" or "</span>"?',
    choices: ['r"<\\w+>"', 'r"</?\\w+>"', 'r"<[^>]+>"', 'r"</?[a-zA-Z]+>"'],
    correctAnswer: 1,
    explanation:
      'Pattern r"</?\\w+>" matches < optionally followed by /, then word characters, then >.',
  },
  {
    id: 'q086',
    question:
      'To match valid variable names in Python (start with letter/underscore, then letters/digits/underscores), what pattern works?',
    choices: [
      'r"[a-zA-Z_]\\w*"',
      'r"[a-zA-Z_][a-zA-Z0-9_]*"',
      'r"^[a-zA-Z_]\\w*$"',
      'A and B are equivalent, C adds anchoring',
    ],
    correctAnswer: 3,
    explanation:
      'Patterns A and B are equivalent (\\w includes [a-zA-Z0-9_]). Pattern C adds anchoring for full string validation.',
  },
  {
    id: 'q087',
    question: 'What pattern would match license plates like "ABC-1234"?',
    choices: [
      'r"[A-Z]{3}-\\d{4}"',
      'r"[A-Za-z]{3}-[0-9]{4}"',
      'r"\\w{3}-\\d{4}"',
      'All could work with different constraints',
    ],
    correctAnswer: 3,
    explanation:
      'Different patterns have different constraints. First allows only uppercase, second allows any case, third allows letters/digits/underscore.',
  },
  {
    id: 'q088',
    question:
      'To validate a simple password (at least 8 characters, letters and digits), what pattern works?',
    choices: ['r"[a-zA-Z0-9]{8,}"', 'r"\\w{8,}"', 'r"^[a-zA-Z0-9]{8,}$"', 'Both A and C work well'],
    correctAnswer: 3,
    explanation:
      'Pattern A matches 8+ alphanumeric characters. Pattern C adds anchoring. Pattern B includes underscore which may not be desired.',
  },
  {
    id: 'q089',
    question:
      'What pattern would extract domain names from URLs like "https://www.example.com/path"?',
    choices: [
      'r"https?://([^/]+)"',
      'r"://([^/]+)"',
      'r"https?://www\\.([^/]+)"',
      'Both A and B work',
    ],
    correctAnswer: 3,
    explanation:
      'Both patterns capture the domain part. Pattern A is more specific to http/https, pattern B is more general.',
  },
  {
    id: 'q090',
    question: 'To match temperature readings like "72°F" or "22°C", what pattern works?',
    choices: ['r"\\d+°[FC]"', 'r"[0-9]+°[CF]"', 'r"\\d+°[FC]"', 'All of the above'],
    correctAnswer: 3,
    explanation:
      'All patterns match digits followed by degree symbol and F or C. They differ slightly in character class notation.',
  },
  {
    id: 'q091',
    question: 'What pattern would match MAC addresses like "AA:BB:CC:DD:EE:FF"?',
    choices: [
      'r"[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}"',
      'r"([A-Fa-f0-9]{2}:){5}[A-Fa-f0-9]{2}"',
      'r"[A-Fa-f0-9:]{17}"',
      'Both A and B',
    ],
    correctAnswer: 3,
    explanation:
      'Patterns A and B correctly match MAC address format. Pattern C is less precise (allows colons anywhere).',
  },
  {
    id: 'q092',
    question: 'To match coordinates like "40.7128, -74.0060", what pattern works?',
    choices: [
      'r"-?\\d+\\.\\d+, -?\\d+\\.\\d+"',
      'r"-?[0-9]+\\.[0-9]+, -?[0-9]+\\.[0-9]+"',
      'r"-?\\d{1,3}\\.\\d+, -?\\d{1,3}\\.\\d+"',
      'Both A and B',
    ],
    correctAnswer: 3,
    explanation:
      'Patterns A and B both match optional minus, digits, dot, digits, comma space, repeat. Pattern C is more restrictive on integer part.',
  },
  {
    id: 'q093',
    question: 'What pattern would match ISBN numbers like "978-0-123456-78-9"?',
    choices: [
      'r"\\d{3}-\\d-\\d{6}-\\d{2}-\\d"',
      'r"[0-9]{3}-[0-9]-[0-9]{6}-[0-9]{2}-[0-9]"',
      'r"978-0-\\d{6}-\\d{2}-\\d"',
      'Both A and B',
    ],
    correctAnswer: 3,
    explanation:
      'Patterns A and B match the ISBN-13 format. Pattern C is more specific to 978-0 prefix but less flexible.',
  },
  {
    id: 'q094',
    question:
      'To extract hashtags that contain only letters (like #Python but not #Python3), what pattern works?',
    choices: ['r"#[a-zA-Z]+"', 'r"#[A-Za-z]+"', 'r"#[^\\d\\s]+"', 'Both A and B'],
    correctAnswer: 3,
    explanation:
      'Patterns A and B both match # followed by only letters. Pattern C allows any non-digit, non-space characters.',
  },
  {
    id: 'q095',
    question: 'What pattern would match version numbers like "1.2.3" or "10.0.1"?',
    choices: [
      'r"\\d+\\.\\d+\\.\\d+"',
      'r"[0-9]+\\.[0-9]+\\.[0-9]+"',
      'r"\\d{1,2}\\.\\d{1,2}\\.\\d{1,2}"',
      'Both A and B are most flexible',
    ],
    correctAnswer: 3,
    explanation:
      'Patterns A and B allow any number of digits in each version part. Pattern C limits to 1-2 digits, which may be too restrictive.',
  },
  {
    id: 'q096',
    question: 'To match scientific notation like "1.23e-4" or "5.67E+8", what pattern works?',
    choices: [
      'r"\\d+\\.\\d+[eE][+-]?\\d+"',
      'r"[0-9]+\\.[0-9]+[eE][+-]?[0-9]+"',
      'r"\\d\\.\\d+[eE][+-]\\d+"',
      'Both A and B',
    ],
    correctAnswer: 3,
    explanation:
      'Patterns A and B match digits.digits followed by e/E, optional +/-, and more digits. Pattern C is more restrictive.',
  },
  {
    id: 'q097',
    question: 'What pattern would match UUID format like "550e8400-e29b-41d4-a716-446655440000"?',
    choices: [
      'r"[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}"',
      'r"[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}"',
      'r"\\w{8}-\\w{4}-\\w{4}-\\w{4}-\\w{12}"',
      'Both A and B',
    ],
    correctAnswer: 3,
    explanation:
      'Patterns A and B correctly match UUID format. A allows lowercase hex, B allows any case hex. C is incorrect (\\w includes underscore).',
  },
  {
    id: 'q098',
    question:
      'To match Roman numerals like "XIV" or "MCMLIV", what basic pattern could start you off?',
    choices: [
      'r"[IVXLCDM]+"',
      'r"[IVX]+"',
      'r"M*D?C{0,4}L?X{0,4}V?I{0,4}"',
      'A is simplest for basic matching',
    ],
    correctAnswer: 3,
    explanation:
      'Pattern A matches any combination of Roman numeral letters, which is a good start. Pattern C is more precise but complex.',
  },
  {
    id: 'q099',
    question: 'What pattern would match simple mathematical expressions like "2+3" or "10*5"?',
    choices: [
      'r"\\d+[+\\-*/]\\d+"',
      'r"[0-9]+[+\\-*/][0-9]+"',
      'r"\\d+\\s*[+\\-*/]\\s*\\d+"',
      'All of the above work',
    ],
    correctAnswer: 3,
    explanation:
      'All patterns work. Pattern C is most flexible, allowing optional whitespace around operators.',
  },
  {
    id: 'q100',
    question: "What's the most important principle when writing regex for real-world use?",
    choices: [
      'Make it as short as possible',
      'Make it as specific as possible',
      'Balance specificity with flexibility based on your needs',
      'Always use the most complex pattern',
    ],
    correctAnswer: 2,
    explanation:
      'Balance is key. Too specific and you miss valid inputs; too general and you match invalid inputs. Consider your specific use case and requirements.',
  },
];
